import React, { createContext, useState, useContext, ReactNode } from 'react';

interface AdminAccessContextType {
  hasAdminAccess: boolean;
  isTrueAdmin: boolean;
  toggleAdminAccess: () => void;
}

const AdminAccessContext = createContext<AdminAccessContextType | undefined>(undefined);

export const useAdminAccess = (): AdminAccessContextType => {
  const context = useContext(AdminAccessContext);
  if (!context) {
    throw new Error('useAdminAccess must be used within an AdminAccessProvider');
  }
  return context;
};

interface AdminAccessProviderProps {
  children: ReactNode;
  initialAdminAccess?: boolean;
  isTrueAdmin?: boolean;
}

export const AdminAccessProvider: React.FC<AdminAccessProviderProps> = ({ 
  children, 
  initialAdminAccess = false,
  isTrueAdmin = false
}) => {
  const [hasAdminAccess, setHasAdminAccess] = useState(initialAdminAccess);

  const toggleAdminAccess = () => {
    setHasAdminAccess(prev => !prev);
  };

  return (
    <AdminAccessContext.Provider value={{ hasAdminAccess, isTrueAdmin, toggleAdminAccess }}>
      {children}
    </AdminAccessContext.Provider>
  );
};
